import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import {
  categoriesGetAll,
  itemsGetAll,
  modifiersGetModifierGroup,
} from "~/api-refs";
import { ModifierGroupEditPage } from "~/components/menus/modifiers/detail/modifier-group-edit-page";
import { LoadingPanel } from "~/components/shared/loading-panel";
import { toConvexTableId } from "~/lib/convex-table-id";

export const Route = createFileRoute(
  "/_authenticated/menus/$menuId/modifiers/$modifierGroupId"
)({
  component: ModifierGroupPage,
});

function ModifierGroupPage() {
  const { modifierGroupId } = Route.useParams();

  const { data: modifierGroup, isPending: modifierGroupLoading } = useQuery(
    convexQuery(modifiersGetModifierGroup, {
      modifierGroupId: toConvexTableId("modifierGroups", modifierGroupId),
    })
  );

  const { data: categoriesResult, isPending: categoriesLoading } = useQuery(
    convexQuery(categoriesGetAll, {
      paginationOpts: {
        numItems: 100,
        cursor: null,
      },
    })
  );

  const { data: itemsResult, isPending: itemsLoading } = useQuery(
    convexQuery(itemsGetAll, {
      paginationOpts: {
        numItems: 100,
        cursor: null,
      },
    })
  );

  if (modifierGroupLoading || categoriesLoading || itemsLoading) {
    return <LoadingPanel message="Loading modifier group..." />;
  }

  if (!(modifierGroup && categoriesResult && itemsResult)) {
    throw new Error("Required data not found");
  }

  const categoriesList = categoriesResult.page;
  const itemsList = itemsResult.page;

  return (
    <>
      <ModifierGroupEditPage
        categoriesList={categoriesList}
        itemsList={itemsList}
        modifierGroup={modifierGroup}
      />
      {/* Outlet for child routes (e.g., /delete modal) */}
      <Outlet />
    </>
  );
}
